import './stylitics.css';

/* eslint-disable no-undef */
export default (sectionEl, data) => {
  const {
    initialProductId,
    badge,
    outfitMin,
    outfitMax,
    orderCategory,
    handleProduct,
  } = data;
  const categoriesArray = orderCategory.split(', ');

  const init = () => {
    const widgetInstance = new StyliticsClassicWidget(
      'tuckernuck',
      'stylitics-widget-container',
      {
        api: {
          item_number: `${initialProductId}`,
          min: `${outfitMin}`,
          max: `${outfitMax}`,
        },
        responsive: [
          [0, { columns: 1 }],
          [640, { columns: 3 }],
        ],
        display: {
          disableMnM: true,
          swipeableCarouselNextItemPeek: 0,
        },
        text: {
          viewDetailsCTA: window.TMW.Strings.product.shopTheLookCta,
        },
      },
    );

    if (badge) {
      widgetInstance.on('mount', 'bundle', ({ bundle, element }) => {
        if (bundle['on-model-image']) {
          const mobileClass =
            outfitMax > 2 ? 'w-[70px] sm-mobile-width' : 'w-[70px]';
          const badgeImg = document.createElement('img');
          badgeImg.className = mobileClass;
          badgeImg.setAttribute('src', badge.src);
          badgeImg.setAttribute('alt', badge.alt);
          element
            .querySelector('.stylitics-bundle-badge')
            .appendChild(badgeImg);
        }
      });
    }
    return widgetInstance;
  };

  const configureEvents = (widget) => {
    window.addEventListener('swatch:change', (event) => {
      const { id } = event.detail?.product ?? {};
      widget.refresh({ api: { item_number: id } });
    });

    window.addEventListener('stylitics:add-to-cart', (event) => {
      const { product, currentVariant } = event.detail;
      const itemId = product.id.split('/Product/')[1];
      const price = parseFloat(currentVariant.price.amount);
      widget.trackAddItemToCart(itemId, price);
    });

    window.addEventListener('stylitics:item-click', (event) => {
      const { product } = event.detail;
      const itemId = product.id.split('/Product/')[1];
      widget.trackClickItem(itemId);
    });

    widget.on('mount', 'bundles', (response) => {
      if (response.bundles && response.bundles.length) {
        sectionEl.classList.remove('hidden');
      } else {
        sectionEl.classList.add('hidden');
      }
    });

    // Open quick view
    widget.override('click', 'bundle', (payload) => {
      const categoryIndex = categoriesArray.reduce((acc, category, index) => {
        acc[category] = index + 1;
        return acc;
      }, {});

      const mainProduct = payload.bundle.items.find(
        (item) => item.remote_id === payload.bundle.primary_remote_id,
      );
      const otherProducts = payload.bundle.items.filter(
        (item) => item.remote_id !== payload.bundle.primary_remote_id,
      );
      const defaultIndex = Math.floor(Math.random() * 101) + 100;

      const sortedProducts = otherProducts
        .sort((a, b) => {
          const indexA = categoryIndex[a.department] || defaultIndex;
          const indexB = categoryIndex[b.department] || defaultIndex;
          return indexA - indexB;
        })
        .map((item) => item.affiliate_link.split('/products/')[1]);

      sortedProducts.unshift(mainProduct.affiliate_link.split('/products/')[1]);
      const openLookAddEvent = new CustomEvent('openLookAdd', {
        detail: {
          products: sortedProducts,
          stylitics: true,
          id: payload.bundle.id,
          name: `stylitics:${handleProduct}:${payload.bundle.position}`,
        },
      });

      window.dispatchEvent(openLookAddEvent);
    });

    widget.start();
  };

  const widget = init(initialProductId, badge);
  configureEvents(widget);
};
